import { TCompanyFeatureType } from 'FeatureModules/Auth/types/company.types';
import useUserData from './useUserData';

const useCompanyFeatureFlags = () => {
  const { company } = useUserData();

  const isCompanyFeatureEnabled = (feature: TCompanyFeatureType) => {
    return !!company?.planDetails?.features.includes(feature);
  };

  return { isCompanyFeatureEnabled };
};

export default useCompanyFeatureFlags;
